import styled from 'styled-components';

const s = {
  time: styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    float: right;
    color: #ffffff;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;

    @media only screen and (max-width: 480px), (orientation: landscape) and (max-width: 767px) {
      height: 13px;
    }
  `,

  timeStart: styled.div`
    font-family: 'Pluto Sans SemiBold';
    height: 24px;
    color: #a8a8a8;
    font-size: 14px;
    line-height: 20px;
    padding-right: 10px;
    display: ${({ playerIsFullscreen }) => (playerIsFullscreen ? 'block' : 'none')};

    @media only screen and (max-width: 480px), (orientation: landscape) and (max-width: 767px) {
      display: block;
      font-family: ${(props) =>
        props.playerIsFullscreen ? '"Pluto Sans SemiBold"' : '"Pluto Sans SemiBold"'};
      font-size: ${(props) => (props.playerIsFullscreen ? '12px' : '12px')};
      height: 19px;
    }
  `,

  timeEnd: styled.div`
    font-family: 'Pluto Sans SemiBold';
    height: 24px;
    color: #a8a8a8;
    font-size: 14px;
    line-height: 20px;
    padding-left: 10px;
    display: ${({ playerIsFullscreen }) => (playerIsFullscreen ? 'block' : 'none')};

    @media only screen and (max-width: 480px), (orientation: landscape) and (max-width: 767px) {
      display: block;
      font-size: 12px;
      height: 19px;
    }
  `,
};

export default s;
